import {useEffect, useMemo, useState} from "react";
import ReportUtils from "../../../../../../utils/report-utils.js";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import EditorButton from "../../../../../../components/reports/editor-report/editor-button.jsx";
import EditorInput from "../../../../../../components/reports/editor-report/editor-input.jsx";

export default function OccurrenceByDay({ data, setMode }) {
    const [callEditor, setCallEditor] = useState(false);

    const byDayChart = useMemo(() => {
        const source = Array.isArray(data?.temp_analysis)
            ? data.temp_analysis.filter(item => item?.source === "by_day")
            : [];

        const dayMap = new Map();

        for (const item of source) {
            const day = item?.by_day;
            const qty = Number(item?.qty ?? 0);

            if (!day) continue;

            dayMap.set(day, (dayMap.get(day) || 0) + qty);
        }

        const entries = Array.from(dayMap.entries()).map(([label, value]) => ({ label, value }));

        return {
            labels: entries.map(item => ReportUtils.formatDateLabel(item.label)),
            values: entries.map(item => item.value),
            canRender: entries.length > 0 && entries.length <= 31,
        };
    }, [data]);

    useEffect(() => {
        GraphicUtils.lineChart(
            "occurrence-by-day",
            [["Ocorrências", ...byDayChart.values]],
            byDayChart.labels,
        );
    }, [byDayChart]);

    return (
        <>
            <div className="chart-report">
                <div className="flex flex-row gap-2">
                    <span className="chart-title">Ocorrências por dia</span>
                    <EditorButton callEditor={callEditor} setCallEditor={setCallEditor}/>
                </div>

                <div className="mt-3" id="occurrence-by-day"/>
            </div>

            <EditorInput callEditor={callEditor} setMode={setMode}/>
            <div className="chart-divisor"/>
        </>
    )
}